import Buttons from "components/molecules/buttons";
import { Form } from "components/organisms";
import {
  musicProductDigitalInitialValues,
  musicProductDigitalTabs,
} from "components/organisms/forms/music-product-digital/MusicProductDigitalForm";
import { useParamId } from "hooks/useParamId";
import middleware from "middleware";
import { useLocation, useNavigate } from "react-router-dom";
import { PopupActions } from "reactjs-popup/dist/types";
import {
  useDeleteMusicProductDigital,
  useGetMusicProductDigital,
} from "services/music-product-digital";
import { STATUS } from "services/types";
import { getMainTitle } from "utils/global/mainTitle.utils";
import { getLastTabPathname } from "utils/navbar/getParentPathname";
import { onErrorShowToast } from "utils/service/errorHandler";

const MusicProductDigital = () => {
  const musicProductDigitalId = useParamId("music-product-digital");
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { data: musicProductDigital, isLoading } = useGetMusicProductDigital(
    musicProductDigitalId,
  );

  const removeMusicProductDigital = useDeleteMusicProductDigital(
    musicProductDigitalId,
  );

  const musicProductDigitalIndividualInitialValues = musicProductDigital
    ? middleware.musicProductDigital.queryToForm(musicProductDigital)
    : musicProductDigitalInitialValues;

  const goToEditMusicProductDigital = () => {
    musicProductDigital &&
      navigate(
        `/music-product-digital/edit/${musicProductDigitalId}/${getLastTabPathname(
          pathname,
        )}`,
        {
          replace: true,
        },
      );
  };

  const onRemoveMusicProductDigital = async (actions: PopupActions) => {
    await removeMusicProductDigital.mutateAsync(undefined, {
      onError: (error) => {
        actions.close();
        onErrorShowToast(error);
      },
      onSuccess: () => navigate("/music-product-digital"),
    });
  };

  return (
    <Form.MusicProductDigital
      i18nextPrefix="music-product-digital"
      onSubmit={() => {}}
      initialValues={musicProductDigitalIndividualInitialValues}
      tittle={getMainTitle(musicProductDigital?.mainTitle)}
      disableTabs={
        musicProductDigital?.canSendDigitalDelivery === false ||
        musicProductDigital?.releaseStatus === STATUS.draft
          ? [musicProductDigitalTabs.delivery]
          : []
      }
      backPath="music-product-digital"
      status={{ displayMode: true, isLoading }}
      topbarContent={
        <Buttons.IndividualPage
          onClick={goToEditMusicProductDigital}
          name={musicProductDigital?.mainTitle.title}
          onRemove={onRemoveMusicProductDigital}
        />
      }
    />
  );
};

export default MusicProductDigital;
